import { useState } from 'react';
import throttle from 'lodash.throttle';

import { useIsomorphicLayoutEffect } from '@/hooks/useIsomorphicLayoutEffect';

export function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState<number | null>(null);

  useIsomorphicLayoutEffect(() => {
    const handleWindowWidthChange = throttle(
      () => setWindowWidth(window.innerWidth),
      500,
    );

    window.addEventListener(`resize`, handleWindowWidthChange);

    handleWindowWidthChange();

    return () => window.removeEventListener(`resize`, handleWindowWidthChange);
  }, [windowWidth]);

  return { windowWidth };
}
